import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { BASE_URL } from '../config/api';
import SEOHead from '../components/SEOHead';
import './EquipmentList.css';

const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BASE_URL}${path.startsWith('/') ? '' : '/media/'}${path}`;
};

const EquipmentList = () => {
  const { i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchItems = async () => {
      try {
        const res = await api.get('/content/equipment/');
        setItems(res.data?.results || res.data || []);
      } catch (e) {
        setError(i18n.language === 'ka' ? 'ინვენტარის ჩატვირთვა ვერ მოხერხდა' : 'Failed to load equipment');
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
  }, [i18n.language]);

  const localized = useMemo(() => {
    const isKa = i18n.language === 'ka';
    return items.map((it) => ({
      ...it,
      title: (isKa ? (it.title_ka || it.title_en) : (it.title_en || it.title_ka)) || '',
      short: (isKa ? (it.short_description_ka || it.short_description_en) : (it.short_description_en || it.short_description_ka)) || '',
      photoUrl: getImageUrl(it.main_photo),
    }));
  }, [items, i18n.language]);

  return (
    <div className="equipment-page">
      <SEOHead
        title="Our Equipment | GFM Studio"
        description="See the professional broadcast and production equipment used by GFM Studio."
        path="/about/equipment"
      />
      <div className="equipment-header">
        <h1>{i18n.language === 'ka' ? 'ჩვენი აღჭურვილობა' : 'Our Equipment'}</h1>
      </div>

      {loading ? (
        <div className="equipment-loading">{i18n.language === 'ka' ? 'იტვირთება...' : 'Loading...'}</div>
      ) : error ? (
        <div className="equipment-error">{error}</div>
      ) : (
        <div className="equipment-grid">
          {localized.length === 0 ? (
            <div className="equipment-empty">
              {i18n.language === 'ka' ? 'აღჭურვილობა არ მოიძებნა' : 'No equipment found'}
            </div>
          ) : (
            localized.map((it) => (
              <Link key={it.id} to={`/about/equipment/${it.slug}`} className="equipment-card">
                <div className="equipment-card-media">
                  {it.photoUrl ? (
                    <img src={it.photoUrl} alt={it.title} loading="lazy" />
                  ) : (
                    <div className="equipment-card-media-placeholder" />
                  )}
                </div>
                <div className="equipment-card-body">
                  <h2 className="equipment-card-title">{it.title}</h2>
                  {it.short ? (
                    <div className="equipment-card-desc">{it.short}</div>
                  ) : null}
                </div>
              </Link>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default EquipmentList;

